import React from "react";

import { Training } from "models";

import { IAccessibilityContent } from "pages/MainPage/MainPage";

import { EmptyData } from "components/common/EmptyData";

import { EditPanel } from "../EditPanel";
import { FurtherInformation } from "../FurtherInformation";

import "./TrainingSection.scss";

export interface ITrainingSectionContent extends IAccessibilityContent {
  trainingHeader: string;
  noTrainingPlaceholder: string;
}

export interface ITrainingSectionProps {
  editTraining: () => void;
  isReadonly: boolean;
  content: ITrainingSectionContent;
  training?: Training;
}

export const TrainingSection: React.FC<
  React.PropsWithChildren<ITrainingSectionProps>
> = (props) => {
  const {
    editTraining,
    training: { notes = "" } = {},
    isReadonly,
    content,
  } = props;

  let trainingContent: React.ReactNode = null;

  if (notes === "") {
    trainingContent = (
      <EmptyData theme="light" text={content.noTrainingPlaceholder} />
    );
  } else {
    trainingContent = <FurtherInformation text={notes} />;
  }

  return (
    <React.Fragment>
      <EditPanel
        header={content.trainingHeader}
        editFn={editTraining}
        hideEdit={isReadonly}
        editLinkAltText={content.editLinkAltText}
      />
      {trainingContent}
    </React.Fragment>
  );
};
